<template>
  <v-app id="inspire">
    <div v-if="loggedIn && user">
      <div>
        <app-bars :user="user" :slackMap="slackMap" />
        <v-main>
          <v-container class="py-8 px-6">
            <router-view />
          </v-container>
        </v-main>
      </div>
    </div>
    <loginView @auth="login()" v-else />
  </v-app>
</template>

<script>
import LoginView from "./views/LoginView.vue";
import AppBars from "./components/appBars/AllBars.vue";
import axios from "@/plugins/axios";
export default {
  name: "App",
  components: {
    LoginView,
    AppBars,
  },

  data: () => ({
    loggedIn: false,
    user: undefined,
    sideBarShown: true,
    slackMap: {},
  }),
  methods: {
    login() {
      axios.defaults.headers.common["q-bot-ui-token"] = sessionStorage.token;
      // Refresh the tab
      window.location.reload();
    },

    toggleSideBar() {
      this.sideBarShown = !this.sideBarShown;
    },
    getData() {
      let that = this;
      axios
        .get("/api/v1/user/me")
        .then((res) => {
          that.user = res.data;
          localStorage.user = JSON.stringify(res.data);
          that.loggedIn = true;
        })
        .catch(() => {
          that.loggedIn = false;
          that.user = undefined;
        });
      axios.get("/api/v1/agents/list").then((res) => {
        that.slackMap = res.data.slackMap;
      });
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style lang="scss">
.apexcharts-legend-text,
.apexcharts-text,
.apexcharts-xaxis-label {
  color: whitesmoke !important;
}
.theme--dark svg text {
  fill: white !important;
}
.theme--dark .apexcharts-legend-text {
  color: white !important;
  fill: white !important;
}
</style>

<style>
::-webkit-scrollbar {
  width: 8px;
  height: 4px;
}
::-webkit-scrollbar-button {
  width: 0px;
  height: 0px;
}
::-webkit-scrollbar-thumb {
  background: #591769;
  border: 12px none #ffffff;
}
::-webkit-scrollbar-thumb:hover {
  background: #ba7bb6;
}
::-webkit-scrollbar-thumb:active {
  background: #82b1ff;
}
::-webkit-scrollbar-track {
  background: #666666;
  border: 0px none #ffffff;
}
::-webkit-scrollbar-track:hover {
  background: #666666;
}
::-webkit-scrollbar-track:active {
  background: #333333;
}
::-webkit-scrollbar-corner {
  background: transparent;
}
</style>
